export default __webpack_public_path__ + "static/media/nest.4007dcc8.svg";